import React from "react";
import { formatDate, isDate } from "../../../../../wp-utils/v1";

const JobModal = ({ job }) => {
  const { title, meta } = job;
  const { company, dead_line, education_qualification, apx_salary, details, age_limit } = meta;
  return (
    <>
      <div className="item mb-3">
        <h3>
          <span className="font-bold mb-0.5 block">Title:</span> {title}
        </h3>
      </div>
      <div className="item mb-3">
        <h3>
          <span className="font-bold mb-0.5 block">Company:</span> {company}
        </h3>
      </div>
      <div className="item mb-3">
        <h3>
          <span className="font-bold mb-0.5 block">Education Qualification: </span>
          {education_qualification}
        </h3>
      </div>
      <div className="item mb-3">
        <h3>
          <span className="font-bold mb-0.5 block">Approximate Salary:</span> {apx_salary}
        </h3>
      </div>
      <div className="item mb-3">
        <h3>
          <span className="font-bold mb-0.5 block">Age Limit:</span> {age_limit}
        </h3>
      </div>
      <div className="item mb-3">
        <h3>
          <span className="font-bold mb-0.5 block">Details:</span> {details}
        </h3>
      </div>
      <div className="item mb-3">
        <h3>
          <span className="font-bold mb-0.5 block">Deadline:</span>
          {isDate(dead_line) ? formatDate(new Date(dead_line), "DD CMM YYYY") : dead_line}
        </h3>
      </div>
    </>
  );
};

export default JobModal;
